import React, {
    useState
} from 'react';
import styled from 'styled-components';
import {
    DropdownLink,
    DropdownMenu
} from './NavbarElements';

const DropdownItemContainer = styled.div `
  position: relative;
  &:hover > ${DropdownMenu} {
    display: flex;
  }
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const SubDropdownMenu = styled(DropdownMenu)
`
  top: 0;
  right: 100%; // Position the sub-menu to the left (RTL)
  display: none;
`;

const LogoImage = styled.img `
  width: 75px;
  height: 75px;
  object-fit: contain;
  opacity: 0.7;
`;

const DropdownItem = ({
        item
    }) => {
        const [showSubMenu, setShowSubMenu] = useState(false);
        const hasChildren = item.subCategories && item.subCategories.length > 0;

        const handleMouseEnter = () => hasChildren && setShowSubMenu(true);
        const handleMouseLeave = () => hasChildren && setShowSubMenu(false);

        return ( <
            DropdownItemContainer onMouseEnter = {
                handleMouseEnter
            }
            onMouseLeave = {
                handleMouseLeave
            } >
            {
                item.logo && < LogoImage src = {
                    item.logo
                }
                alt = {
                    `${item.title} logo`
                }
                />} <
                DropdownLink to = {
                    item.path
                } > {
                    item.title
                } < /DropdownLink>

                {
                    hasChildren && showSubMenu && ( <
                        SubDropdownMenu > {
                            item.subCategories.map((subItem, index) => ( <
                                DropdownItem key = {
                                    index
                                }
                                item = {
                                    subItem
                                }
                                />
                            ))
                        } <
                        /SubDropdownMenu>
                    )
                } <
                /DropdownItemContainer>
            );
        };

        export default DropdownItem;